import {RemotePostQuestionsAndAnswersScheduleScript} from 'data/usecases/private/booking-flow/health';
import {PostQuestionsAndAnswersScheduleScript} from 'domain/usecases/private/booking-flow/health/post-questions-and-answers-schedule-script';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostQuestionsAndAnswersScheduleScript = (): PostQuestionsAndAnswersScheduleScript =>
	new RemotePostQuestionsAndAnswersScheduleScript(
		makeBFFApiUrl(BookingFlowEndPoints.scriptQuestionsAndAnswers),
		makeAuthorizeHttpClientDecorator(),
	);
